import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="py-12 md:py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-heading font-bold text-background-50 mb-4">草榴社区入口</h3>
            <p className="text-sm text-background-300 leading-relaxed">
              最全面的草榴社区入口导航平台，提供最新可用入口地址、镜像站点及访问指南，帮助用户稳定畅享社区内容。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">首页</Link>
              <Link to="/about" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">关于我们</Link>
              <Link to="/category/latest-entrance" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">最新入口</Link>
              <Link to="/category/access-guide" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">访问指南</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">文章分类</h4>
            <div className="flex flex-col gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <div className="flex flex-col gap-2 text-sm text-background-300">
              <span className="whitespace-nowrap">邮箱：contact@caoliu-nav.com</span>
              <span className="whitespace-nowrap">更新频率：每日检查</span>
              <span className="whitespace-nowrap">服务时间：7×24小时</span>
            </div>
          </div>
        </div>

        <div className="border-t border-background-800/50 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            &copy; 2026 草榴社区入口导航. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-background-400 cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</span>
            <span className="text-xs text-background-400 cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">免责声明</span>
            <span className="text-xs text-background-400 cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">友情链接</span>
          </div>
        </div>
      </div>
    </footer>
  );
}